import { getAgGridColId, useDefaultColumns, type AssetTransaction, type ColumnDef } from '@talos/kyoko';
import { useMemo } from 'react';
import type { CustomerAssetTransactionsColumn } from './types';

export const CUSTOMER_ASSET_TRANSACTIONS_COLUMNS = [
  {
    type: 'date',
    field: 'TransactTime',
    title: 'Transact Time',
  },
  {
    type: 'marketAccount',
    field: 'MarketAccount',
    title: 'Market Account',
    initialWidth: 200,
    initialRowGroup: true,
    enableRowGroup: true,
    params: {
      prefixCustomerMarketAccountsWithCpty: true,
    },
  },
  {
    type: 'text',
    field: 'Type',
    title: 'Type',
    initialWidth: 120,
  },
  {
    type: 'asset',
    field: 'PositionAsset',
    title: 'Position Asset',
    initialWidth: 120,
  },
  {
    type: 'size',
    field: 'Amount',
    title: 'Amount',
    initialWidth: 140,
    params: {
      currencyField: 'Asset',
      highlightNegative: true,
    },
  },
  {
    type: 'currency',
    field: 'Asset',
    title: 'Asset',
    initialWidth: 100,
  },
  {
    type: 'percent',
    field: 'Rate',
    title: 'Rate',
    initialWidth: 160,
  },
  {
    type: 'text',
    field: 'TID',
    title: 'TID',
    initialWidth: 100,
    initialHide: true,
  },
  {
    type: 'id',
    field: 'TransactionID',
    title: 'Transaction ID',
    initialWidth: 100,
    initialHide: true,
  },
  {
    type: 'text',
    field: 'SettleStatus',
    title: 'Settle Status',
    initialWidth: 120,
    initialHide: true,
  },
  {
    type: 'text',
    field: 'Revision',
    title: 'Revision',
    initialWidth: 80,
    initialHide: true,
  },
  {
    type: 'text',
    field: 'AllocationStatus',
    title: 'Allocation Status',
    initialWidth: 140,
    initialHide: true,
  },
  {
    type: 'date',
    field: 'Timestamp',
    title: 'Timestamp',
    initialHide: true,
  },
] satisfies ColumnDef<AssetTransaction>[];

interface UseCustomerAssetTransactionsColumnsParams {
  defaultColumns?: CustomerAssetTransactionsColumn[];
}

export function useCustomerAssetTransactionsColumns({
  defaultColumns = [],
}: UseCustomerAssetTransactionsColumnsParams = {}) {
  const columnDefinitions = useMemo(
    () => new Map(CUSTOMER_ASSET_TRANSACTIONS_COLUMNS.map(column => [getAgGridColId(column), column])),
    []
  );

  return useDefaultColumns(defaultColumns, columnDefinitions);
}
